import { render, staticRenderFns } from "./_popin.vue?vue&type=template&id=61ef11cd&scoped=true&"
import script from "./_popin.vue?vue&type=script&lang=js&"
export * from "./_popin.vue?vue&type=script&lang=js&"
import style0 from "./_popin.vue?vue&type=style&index=0&id=61ef11cd&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef11cd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTitle: require('/opt/build/repo/components/PageTitle.vue').default,InputFilters: require('/opt/build/repo/components/InputComponents/InputFilters.vue').default,NewsCard: require('/opt/build/repo/components/NewsCard.vue').default,Layout3Columns: require('/opt/build/repo/components/LayoutComponents/Layout3Columns.vue').default,RichText: require('/opt/build/repo/components/RichComponents/RichText.vue').default,ButtonBlobMore: require('/opt/build/repo/components/ButtonComponents/ButtonBlobMore.vue').default})
